

document.addEventListener('DOMContentLoaded', function() {

setTimeout(() => {
    // Función para cambiar la cantidad de productos, específica a cada tarjeta
    document.querySelectorAll('.mox-subs-container').forEach(container => {
        const quantityDisplay = container.querySelector('.mox-subs-quantity-display');
        let quantity = parseInt(quantityDisplay.textContent);
        container.querySelector('.mox-subs-increase').addEventListener('click', () => {
            quantity++;
            quantityDisplay.textContent = quantity;
        });

        container.querySelector('.mox-subs-decrease').addEventListener('click', () => {
            if (quantity > 1) {
                quantity--;
                quantityDisplay.textContent = quantity;
            }
        });
    });
  
}, "1000");

    const checkboxes = document.querySelectorAll('.pdp-selector-checkbox');

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                checkboxes.forEach(cb => {
                    if (cb.checked == true) {
                        cb.checked = false;
                    }
                });
this.checked = true
            }
        });
    });


  document.querySelectorAll('.t4s-form__product .t4s-swatch__list .t4s-swatch__item').forEach(item => {
    item.addEventListener('click', function () {
      setTimeout(() => {

        let subs_price = document.querySelector('#current_variant_price');
                            
        let current_variant_price = 
          document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product-price ins') ||
          document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product-price');


            if (current_variant_price) {
                let priceText = current_variant_price.textContent;
                let cleanPrice = priceText.replace(/[$.,\s]/g, '');
                subs_price.value = cleanPrice;
            }
    
        // Leer el valor de data-value
        const dataValue = this.getAttribute('data-value-position');

        const match = dataValue.match(/\d+/);
        const number = match ? match[0] : null;

        if (number) {

            document.querySelectorAll('.tab-container .discount-label').forEach(tab => {
                tab.style.display = 'none';
            });

            // Mostrar el elemento correspondiente al número encontrado
            const targetTab = document.querySelector(`.tab-container .dis-standard-${number}`);
            if (targetTab) {
                targetTab.style.display = '';
            }

            document.querySelectorAll('.tab-container .discount-label-subs').forEach(tab => {
                tab.style.display = 'none';
            });

            // Mostrar el elemento correspondiente al número encontrado
            const targetTabSubs = document.querySelector(`.tab-container .dis-standard-subs-${number}`);
            if (targetTabSubs) {
                targetTabSubs.style.display = '';
            }

        }
        calculatePrice()
        $('.tab.active').click();
      }, 50);        
    });
   });

  // Función para actualizar el precio de la variante actual
  function updateVariantPrice() {
    const variantIdField = document.querySelector('input[name="id"]');
    if (!variantIdField) return;
    
    const variantId = variantIdField.value;
    const productVariants = window.productVariants || [];
    const currentVariant = productVariants.find(v => v.id.toString() === variantId);
    
    if (currentVariant) {
      // Obtener el precio (compare_at_price si existe, sino price)
      const variantPrice = currentVariant.compare_at_price > 0 ? currentVariant.compare_at_price : currentVariant.price;
      
      // Actualizar el campo hidden con el precio en centavos
      const currentVariantPriceField = document.querySelector('#current_variant_price');
      if (currentVariantPriceField) {
        currentVariantPriceField.value = variantPrice;
        console.log('💰 Precio de variante actualizado:', variantPrice, 'centavos (', variantPrice / 100, 'pesos)');
      }
      
      // Obtener el descuento
      const subscriptionDiscount = parseFloat(document.querySelector('#subscription_discount')?.value || window.subscriptionDiscount || 0);
      const collectionHandle = document.querySelector('#collection_handle')?.value || window.collectionHandle || '';
      const attributeName = collectionHandle ? `_subscription_${collectionHandle}` : (window.attributeName || '');
      
      // Actualizar el precio mostrado en la UI
      updateSubscriptionPriceDisplay(currentVariant, subscriptionDiscount);
      
      // Si la suscripción está activa, recalcular los campos del formulario
      const subscriptionTab = document.querySelector('#purchaseType_subscribe');
      if (subscriptionTab && subscriptionTab.checked) {
        // Recalcular y actualizar los campos de suscripción
        setTimeout(() => {
          const activeTab = document.querySelector('.tab.active');
          if (activeTab && (activeTab.id === 'compraSubs' || activeTab.classList.contains('active'))) {
            // Simular un clic en la pestaña activa para recalcular
            const syntheticEvent = {
              currentTarget: activeTab,
              target: subscriptionTab,
              preventDefault: () => {},
              stopPropagation: () => {}
            };
            if (typeof showTabContent === 'function') {
              showTabContent(syntheticEvent, 'tab2', subscriptionDiscount, attributeName);
            }
          }
        }, 100);
      }
    } else {
      console.warn('⚠️ Variante no encontrada para ID:', variantId);
    }
  }
  
  // Función para actualizar el precio mostrado en la UI
  function updateSubscriptionPriceDisplay(variant, discount) {
    const variantPrice = variant.compare_at_price > 0 ? variant.compare_at_price : variant.price;
    const subscriptionDiscount = parseFloat(document.querySelector('#subscription_discount')?.value || discount || 0);
    
    if (subscriptionDiscount > 0) {
      // Calcular precio con descuento en centavos
      const discountedPriceInCents = variantPrice * (1 - subscriptionDiscount / 100);
      // Convertir a pesos
      const discountedPrice = discountedPriceInCents / 100;
      
      // Formatear precio
      const formattedPrice = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(discountedPrice);
      
      // Actualizar el elemento que muestra el precio de suscripción
      const finalSubsPrice = document.querySelector('#final-subs-price');
      if (finalSubsPrice) {
        finalSubsPrice.textContent = formattedPrice;
      }
    }
  }

  // Suscribirse al evento de cambio de variante
  // Esperar a que PUB_SUB_EVENTS esté disponible
  function setupVariantChangeListener() {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        console.log('🔄 Variante cambiada (PUB_SUB), actualizando precios de suscripción...', event);
        setTimeout(() => {
          updateVariantPrice();
        }, 150);
      });
      console.log('✅ Listener de cambio de variante (PUB_SUB) configurado');
    } else {
      // Reintentar después de un breve delay
      setTimeout(setupVariantChangeListener, 100);
    }
  }
  
  // Intentar configurar el listener después de que el DOM esté listo
  setTimeout(setupVariantChangeListener, 500);
  
  // También escuchar el evento jQuery variant:changed que usa el tema
  // Este es el evento principal que se dispara cuando cambia la variante
  if (typeof $ !== 'undefined') {
    $(document).on('variant:changed', function(evt) {
      console.log('🔄 Variante cambiada (jQuery variant:changed), actualizando precios...', evt);
      
      if (evt && evt.currentVariant) {
        var variant = evt.currentVariant;
        var variantPrice = variant.price || 0;
        var variantComparePrice = variant.compare_at_price || 0;
        var subscriptionDiscount = parseFloat($("#subscription_discount").val()) || 0;
        
        // Actualizar los campos hidden con los nuevos precios
        $("#current_variant_price").val(variantPrice);
        $("#current_variant_compare_price").val(variantComparePrice);
        $("#base_product_price").val(variantPrice);
        $("#current_variant_id").val(variant.id);
        
        // Calcular precio de suscripción
        var subscriptionPrice = variantPrice;
        if (subscriptionDiscount > 0) {
          subscriptionPrice = variantPrice - (variantPrice * subscriptionDiscount / 100);
        }
        
        // Formatear precios usando formatCurrency si está disponible, sino usar Intl.NumberFormat
        var formatPrice = function(price) {
          if (typeof formatCurrency === 'function') {
            return formatCurrency(price);
          }
          return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(price / 100);
        };
        
        var formattedOneTimePrice = formatPrice(variantPrice);
        var formattedSubscriptionPrice = formatPrice(subscriptionPrice);
        var formattedComparePrice = variantComparePrice > 0 ? formatPrice(variantComparePrice) : '';
        
        // Actualizar precio de compra única
        var oneTimeContainer = $("#compraUnica .mox-subs-price-container span");
        if (oneTimeContainer.length > 0) {
          if (variantComparePrice > 0) {
            oneTimeContainer.html('<del>' + formattedComparePrice + '</del> ' + formattedOneTimePrice);
          } else {
            oneTimeContainer.html(formattedOneTimePrice);
          }
        }
        
        // Actualizar precio de suscripción
        var subsContainer = $("#compraSubs .mox-subs-price-container div");
        if (subsContainer.length > 0) {
          if (variantComparePrice > 0) {
            subsContainer.html('<del>' + formattedComparePrice + '</del> <ins id="final-subs-price">' + formattedSubscriptionPrice + '</ins>');
          } else {
            subsContainer.html('<del>' + formattedOneTimePrice + '</del> <ins id="final-subs-price">' + formattedSubscriptionPrice + '</ins>');
          }
        }
        
        // También actualizar directamente el elemento #final-subs-price si existe
        var finalSubsPrice = $("#final-subs-price");
        if (finalSubsPrice.length > 0) {
          finalSubsPrice.text(formattedSubscriptionPrice);
        }
        
        // Recalcular precios si hay una pestaña activa
        if (typeof calculatePrice === 'function') {
          calculatePrice();
        }
        
        // Actualizar atributos del botón si la pestaña de suscripción está activa
        var compraSubs = document.getElementById('compraSubs');
        if (compraSubs && compraSubs.classList.contains('active')) {
          var deliveryOptions = document.querySelector('#delivery-options');
          var frequency = deliveryOptions ? deliveryOptions.value : '';
          var dcto_suscripcion = parseFloat($("#dcto_suscripcion").val()) || 0;
          var dcto_attribute_name = $("#dcto_attribute_name").val() || '';
          var subscription_price = variantPrice - (variantPrice * dcto_suscripcion / 100);
          
          if (typeof updateAddToCartButton === 'function') {
            updateAddToCartButton(frequency, subscription_price, dcto_suscripcion, dcto_attribute_name, variant.id);
          }
          
          // También actualizar los campos ocultos del formulario si la suscripción está activa
          if (typeof showTabContent === 'function') {
            var activeTab = document.querySelector('.tab.active');
            if (activeTab && (activeTab.id === 'compraSubs' || activeTab.classList.contains('active'))) {
              var syntheticEvent = {
                currentTarget: activeTab,
                target: document.querySelector('#purchaseType_subscribe'),
                preventDefault: function() {},
                stopPropagation: function() {}
              };
              showTabContent(syntheticEvent, 'tab2', dcto_suscripcion, dcto_attribute_name);
            }
          }
        }
        
        console.log('✅ Precios actualizados en tiempo real para variante:', variant.id);
      }
    });
    console.log('✅ Listener de cambio de variante (jQuery variant:changed) configurado');
  }

  
});

const deliveryOptions = document.querySelector("#delivery-options");

// Función para actualizar atributos del botón de agregar al carrito
function updateAddToCartButton(frequency, subscriptionPrice, discountApplied, attributeName, variantId) {
  // Buscar el botón - primero en formularios, luego globalmente
  var addToCartButton = null;
  
  // Buscar en formularios de producto (tanto main-product como featured-product)
  var productForms = document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
  for (var i = 0; i < productForms.length; i++) {
    // Priorizar botones con data-action-atc, luego data-atc-form, luego submit
    addToCartButton = productForms[i].querySelector('[data-action-atc]') || 
                     productForms[i].querySelector('[data-atc-form]') ||
                     productForms[i].querySelector('button[type="submit"][name="add"]');
    if (addToCartButton) break;
  }
  
  // Si no se encuentra, buscar globalmente
  if (!addToCartButton) {
    addToCartButton = document.querySelector('[data-action-atc]') || 
                     document.querySelector('[data-atc-form]') ||
                     document.querySelector('button[type="submit"][name="add"]');
  }
  
  if (!addToCartButton) {
    console.warn('No se encontró el botón de agregar al carrito');
    return;
  }
  
  if (frequency !== null && subscriptionPrice !== null && discountApplied !== null && attributeName) {
    // Modo suscripción: establecer atributos
    // Asegurar que todos los valores sean strings válidos (no null, undefined, o vacíos)
    if (variantId) addToCartButton.setAttribute('data-variant-id', String(variantId));
    addToCartButton.setAttribute('data-variant-subscription_price', String(subscriptionPrice));
    addToCartButton.setAttribute('data-variant-subscription_freq', String(frequency));
    addToCartButton.setAttribute('data-variant-subscription_discount_applied', String(discountApplied));
    addToCartButton.setAttribute('data-variant-dcto_attribute_name', String(attributeName));
    
    // CRÍTICO: interactable.min.js busca [data-action-atc] y lee los atributos del elemento clickeado
    // En featured-product el botón tiene data-atc-form, pero interactable.min.js busca data-action-atc
    // Necesitamos asegurar que el botón tenga data-action-atc ANTES de que se haga clic
    if (!addToCartButton.hasAttribute('data-action-atc')) {
      addToCartButton.setAttribute('data-action-atc', '');
      console.log('Agregado data-action-atc al botón para que interactable.min.js lo detecte');
    }
    
    // También asegurar que tenga data-variant-id si no lo tiene
    if (!addToCartButton.hasAttribute('data-variant-id') && variantId) {
      addToCartButton.setAttribute('data-variant-id', String(variantId));
    }
    
    // Debug: verificar que los atributos se establecieron correctamente
    console.log('Atributos de suscripción establecidos en el botón:', {
      'data-variant-id': addToCartButton.getAttribute('data-variant-id'),
      'data-variant-subscription_price': addToCartButton.getAttribute('data-variant-subscription_price'),
      'data-variant-subscription_freq': addToCartButton.getAttribute('data-variant-subscription_freq'),
      'data-variant-subscription_discount_applied': addToCartButton.getAttribute('data-variant-subscription_discount_applied'),
      'data-variant-dcto_attribute_name': addToCartButton.getAttribute('data-variant-dcto_attribute_name'),
      'data-action-atc': addToCartButton.hasAttribute('data-action-atc'),
      'data-atc-form': addToCartButton.hasAttribute('data-atc-form'),
      'type': addToCartButton.getAttribute('type'),
      'buttonId': addToCartButton.id || 'sin-id',
      'buttonClass': addToCartButton.className
    });
  } else {
    // Modo compra única: remover atributos de suscripción
    addToCartButton.removeAttribute('data-variant-subscription_price');
    addToCartButton.removeAttribute('data-variant-subscription_freq');
    addToCartButton.removeAttribute('data-variant-subscription_discount_applied');
    addToCartButton.removeAttribute('data-variant-dcto_attribute_name');
  }
}

function showTabContent(event, tabId, discountApplied, attributeName) {
  // Ocultar todo el contenido de las pestañas
  var contents = document.querySelectorAll('.tab-content');
  contents.forEach(function(content) {
    content.classList.remove('active');
    content.style.display = 'none';
  });

  // Quitar la clase 'active' de todas las pestañas
  var tabs = document.querySelectorAll('.tab');
  tabs.forEach(function(tab) {
    tab.classList.remove('active');
    tab.classList.add('inactive');
  });

  // Mostrar el contenido seleccionado y marcar la pestaña activa
  var tabContent = document.getElementById(tabId);
  if (tabContent) {
    tabContent.classList.add('active');
    tabContent.style.display = 'block';
    tabContent.style.setProperty('display', 'block', 'important');
  }
  event.currentTarget.classList.add('active');
  event.currentTarget.classList.remove('inactive');

  // Lógica para tab1 (compra única)
  if (tabId === 'tab1') {
    var lineItemField = document.querySelector('.t4s-main-area .line-item-property__field') || 
                        document.querySelector('.line-item-property__field');
    if (lineItemField) {
      lineItemField.innerHTML = '<input id="subscription-price" type="text" name="properties[Compra Unica]">';
    }
    // Limpiar atributos del botón
    updateAddToCartButton(null);
  }

  // Lógica para tab2 (suscripción)
  if (tabId === 'tab2') {
    var deliveryOptionsAvai = document.querySelector('#delivery-options');
    var frequency = deliveryOptionsAvai ? deliveryOptionsAvai.value : '';
    var original_price = parseFloat($("#current_variant_price").val()) || 0;
    var subscription_discount = parseFloat($("#subscription_discount").val()) || 0;
    var subscription_price = original_price - (original_price * subscription_discount / 100);
    var variant_id = $("#current_variant_id").val();
    
    // Validar que tengamos todos los valores necesarios
    if (!frequency || !subscription_price || !discountApplied || !attributeName || !variant_id) {
      console.warn('Faltan valores para la suscripción:', {
        frequency: frequency,
        subscription_price: subscription_price,
        discountApplied: discountApplied,
        attributeName: attributeName,
        variant_id: variant_id
      });
    }
    
    // Actualizar campos ocultos del formulario - buscar en múltiples lugares
    var lineItemField = document.querySelector('.t4s-main-area .line-item-property__field') || 
                        document.querySelector('.line-item-property__field') ||
                        document.querySelector('p.line-item-property__field') ||
                        document.querySelector('form[data-type="add-to-cart-form"] .line-item-property__field');
    
    if (!lineItemField) {
      // Si no existe, crear el campo dentro del formulario
      var productForm = document.querySelector('form[data-type="add-to-cart-form"]') || 
                       document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        lineItemField = document.createElement('p');
        lineItemField.className = 'line-item-property__field';
        lineItemField.style.display = 'none';
        // Insertar antes del botón de submit
        var submitButton = productForm.querySelector('button[type="submit"], button[data-atc-form]');
        if (submitButton) {
          productForm.insertBefore(lineItemField, submitButton);
        } else {
          productForm.appendChild(lineItemField);
        }
      }
    }
    
    if (lineItemField) {
      lineItemField.innerHTML = `
        <input id="subscription-price" type="hidden" name="properties[_subscription_price]" value="${subscription_price}">
        <input id="subscription-freq" type="hidden" name="properties[_subscription_freq]" value="${frequency}">
        <input type="hidden" name="properties[_subscription_discount_applied]" value="${discountApplied}">       
        <input id="${attributeName}" type="hidden" name="properties[${attributeName}]" value="${discountApplied}">
      `;
      console.log('Campos ocultos actualizados:', lineItemField.innerHTML);
    } else {
      console.warn('No se encontró ni se pudo crear el campo line-item-property__field');
    }
    
    // Actualizar atributos del botón inmediatamente y también con delays
    // para asegurar que se establezcan antes de cualquier clic
    updateAddToCartButton(frequency, subscription_price, discountApplied, attributeName, variant_id);
    
    // También actualizar con delays para asegurar que se ejecute después de otros scripts
    // Usar más delays y más tiempo para featured-product que puede cargar más tarde
    [50, 100, 200, 300, 500, 750, 1000].forEach(function(delay) {
      setTimeout(function() {
        updateAddToCartButton(frequency, subscription_price, discountApplied, attributeName, variant_id);
      }, delay);
    });
    
    // También actualizar cuando el DOM esté completamente listo
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
          updateAddToCartButton(frequency, subscription_price, discountApplied, attributeName, variant_id);
        }, 100);
      });
    }
  }

  // Listener para cambios de frecuencia
  setTimeout(function() {
    var deliveryOptions = document.querySelector("#delivery-options");
    var subscriptionFreq = document.querySelector("#subscription-freq");
    
    if (deliveryOptions && subscriptionFreq) {
      deliveryOptions.addEventListener("change", function() {
        var newFrequency = this.value;
        subscriptionFreq.value = newFrequency;
        
        // Actualizar atributo del botón si está en modo suscripción
        var addToCartButton = null;
        var productForms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < productForms.length; i++) {
          addToCartButton = productForms[i].querySelector('[data-action-atc]') || 
                           productForms[i].querySelector('[data-atc-form]') ||
                           productForms[i].querySelector('button[type="submit"][name="add"]');
          if (addToCartButton) break;
        }
        
        if (!addToCartButton) {
          addToCartButton = document.querySelector('[data-action-atc]') || 
                           document.querySelector('[data-atc-form]') ||
                           document.querySelector('button[type="submit"][name="add"]');
        }
        
        if (addToCartButton && addToCartButton.hasAttribute('data-variant-subscription_price')) {
          var original_price = parseFloat($("#current_variant_price").val()) || 0;
          var subscription_discount = parseFloat($("#subscription_discount").val()) || 0;
          var subscription_price = original_price - (original_price * subscription_discount / 100);
          var variant_id = $("#current_variant_id").val();
          var discountApplied = $("#subscription_discount").val();
          var attributeName = $("#dcto_attribute_name").val();
          
          // Actualizar todos los atributos del botón
          updateAddToCartButton(newFrequency, subscription_price, discountApplied, attributeName, variant_id);
          
          // También actualizar el campo oculto si existe
          var productForm = document.querySelector('form[data-type="add-to-cart-form"]') || 
                           document.querySelector('form[action*="/cart/add"]');
          if (productForm) {
            var subscriptionFreqField = productForm.querySelector('input[name="properties[_subscription_freq]"]');
            if (subscriptionFreqField) {
              subscriptionFreqField.value = newFrequency;
            }
          }
        }
      });
    }
  }, 500);
}

// NOTA: El interceptor de clic fue removido porque ya no es necesario.
// interactable.min.js ahora lee directamente los campos ocultos del formulario,
// por lo que no necesitamos sincronizar los atributos del botón antes del clic.
